import React, { useState, useEffect } from "react";
import "./Footer.css";
import logo from "../../assets/images/footer/logo-btm.webp";
import icon1 from "../../assets/images/footer/footer-icon1.webp";
import icon2 from "../../assets/images/footer/footer-icon2.webp";
import icon3 from "../../assets/images/footer/footer-icon3.webp";
import icon4 from "../../assets/images/footer/footer-icon4.webp";
import icon5 from "../../assets/images/footer/footer-icon5.webp";
import icon6 from "../../assets/images/footer/footer-icon6.webp";
import wechatQr from "../../assets/images/wechatQr.webp";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";

function Footer() {
  const [showWechatQr, setShowWechatQr] = useState(false);

  useEffect(() => {
    const handleGlobalClick = () => {
      setShowWechatQr(false);
    };

    if (showWechatQr) {
      window.addEventListener('click', handleGlobalClick);
    }

    return () => {
      window.removeEventListener('click', handleGlobalClick);
    };
  }, [showWechatQr]);
  const { t, i18n } = useTranslation();
  const location = useLocation(); // Use useLocation to get the current path
  const currentPath = location.pathname;
  const history = useHistory();

  const isActive = (path) => {
    if (path === "default" && (currentPath === "/" || currentPath === "")) {
      return "active";
    }
    return currentPath.endsWith(path) ? "active" : "";
  };

  const handleDownloadClick = (type) => {
    if (type === "home") {
      history.push("/");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (type === "contact") {
      history.push("/contact");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (type === "download") {
      history.push("/download");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (type === "blog") {
      history.push("/blog");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleMailClick = (e) => {
    e.preventDefault();
    window.location.href = "mailto:support@ikiai.org";
  };

  return (
    <footer className="footer-wrapper">
      <div className="container">
        <div className="footer-view">
          <div className="logo-name">
            <img className="logo-img" src={logo} alt="" />
            {/* <span className="logo-text">IKI AI</span> */}
          </div>
          <div className="footer-social-view">
            <a href="https://www.instagram.com/chatwithiki" target="_blank" rel="noopener noreferrer" className="social-button"><img src={icon1} alt="Instagram" /></a>
            <a href={i18n.language.startsWith('zh') ? "https://v.douyin.com/LQ7VBSyzcLM/" : "https://www.tiktok.com/@chatwithiki"} target="_blank" rel="noopener noreferrer" className="social-button"><img src={icon2} alt="TikTok" /></a>
            <a href="https://xhslink.com/m/EOFIFeN5RX" target="_blank" rel="noopener noreferrer" className="social-button"><img src={icon3} alt="XiaoHongShu" /></a>
            <div 
              className="social-button wechat-container"
              onMouseEnter={() => setShowWechatQr(true)}
              onMouseLeave={() => setShowWechatQr(false)}
              onClick={(e) => {
                e.stopPropagation();
                setShowWechatQr(!showWechatQr);
              }}
            >
              <img src={icon4} alt="WeChat" />
              {showWechatQr && (
                <div className="footer-wechat-popup" onClick={(e) => e.stopPropagation()}>
                  <img src={wechatQr} alt="WeChat QR" />
                </div>
              )}
            </div>
            <button onClick={handleMailClick} className="social-button"><img src={icon5} alt="Mail" /></button>
            <a href="https://discord.com/invite/a8GXTmtMZe" target="_blank" rel="noopener noreferrer" className="social-button"><img src={icon6} alt="Discord" style={{ width: 56, height: 56 }} /></a>
          </div>
          <div className="footer-items-view">
            <div className="topView" style={{ marginBottom: "8px" }}>
              <button
                className={isActive("default")}
                onClick={() => {
                  handleDownloadClick("home");
                }}
              >
                {t("btm.started")}
              </button>
              <button
                className={isActive("download")}
                onClick={() => {
                  handleDownloadClick("download");
                }}
              >
                {t("btm.download")}
              </button>
            </div>
            <div className="btmView">
              <button
                className={isActive("blog")}
                onClick={() => {
                  handleDownloadClick("blog");
                }}
              >
                {t("nav.blog")}
              </button>
              <button
                className={isActive("contact")}
                onClick={() => {
                  handleDownloadClick("contact");
                }}
              >
                {t("btm.contact")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;